﻿import DefaultApp from './defaultApp';

const paymentStatusApp = {
    ...DefaultApp,
    data() {
        return {
            ...DefaultApp.data(),
            statusApi: '',
            loading: false,
            state: ''
        }
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;
            const statusResponse = await await this.fetchData({} , this.statusApi, 'get');
            this.loading = false;
            if (statusResponse.status === 200) {
                this.state = statusResponse.data.statusAlias.toLowerCase();
            } else {
                this.generalError = true;
            }
        }
    },
    mounted() {
        if (this.$el.dataset.statusapi) this.statusApi = this.$el.dataset.statusapi;
        this.init();
    }
}

export default paymentStatusApp;